import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";

import { RecordingControls } from "./RecordingControls";
import { TranscribingIndicator } from "./TranscribingIndicator";
import { useVoiceInput } from "./useVoiceInput";

interface VoiceInputButtonProps {
  disabled?: boolean;
  onActiveChange?: (isActive: boolean) => void;
  onTranscript: (text: string) => void;
}

export const VoiceInputButton = ({
  disabled = false,
  onActiveChange,
  onTranscript,
}: VoiceInputButtonProps) => {
  const {
    cancelRecording,
    handleBlob,
    showRecordingError,
    startRecording,
    status,
  } = useVoiceInput({
    disabled,
    onActiveChange,
    onTranscript,
  });

  if (status === "recording") {
    return (
      <RecordingControls
        onBlob={handleBlob}
        onCancel={cancelRecording}
        onError={showRecordingError}
      />
    );
  }

  if (status === "transcribing") {
    return (
      <div className="flex w-full items-center justify-between gap-3">
        <TranscribingIndicator />
        <IconButton
          icon="arrow-up"
          variant="primary"
          size="sm"
          aria-label={t("circle_ai_home.voice.transcribing")}
          loading
          disabled
        />
      </div>
    );
  }

  return (
    <Tooltip content={t("circle_ai_home.composer_voice_input_button_tooltip")}>
      <IconButton
        icon="microphone"
        variant="ghost"
        size="sm"
        aria-label={t("circle_ai_home.voice.start")}
        disabled={disabled}
        onClick={startRecording}
      />
    </Tooltip>
  );
};
